<template>
    <form @submit.prevent="submit">
        <FieldWithLabel
            id="name"
            v-model="form['name']"
            label="會員名稱"
            placeholder="請輸入會員名稱"
            :disabled="submitting || disabled"
        />

        <div class="grid grid-cols-5 gap-x-3">
            <FieldWithLabel
                id="country_code"
                class="col-span-2"
                label="區號"
                placeholder="電話區號"
                v-model="form.country_code"
                type="select"
                :disabled="submitting || disabled"
                :options="countryCodeOptions"
            />
            <FieldWithLabel
                id="tel"
                class="col-span-3"
                v-model="form.tel"
                label="電話號碼"
                placeholder="聯絡電話"
                :disabled="submitting || disabled"
            />
        </div>

        <VerifyTelField
            v-model="form['tel_verify_code']"
            id="tel_verify_code"
            label="短訊認證碼"
            placeholder="短訊認證碼"
            :tel="form.tel"
            :code="form.country_code"
            :authtype="form.type"
            :disabled="submitting || disabled"
        />

        <!-- <v-field class="mb-4" :error="errors['email']">
      <input
        class="field"
        type="email"
        v-model="form['email']"
        placeholder="電郵(選填)"
        :disabled="submitting || disabled"
      />
    </v-field> -->

        <FieldWithLabel
            id="password"
            type="password"
            v-model="form['password']"
            label="密碼"
            placeholder="請輸入密碼"
            :disabled="submitting || disabled"
        />

        <FieldWithLabel
            id="password_confirmation"
            type="password"
            v-model="form['password_confirmation']"
            label="確認密碼"
            placeholder="請再次輸入密碼"
            :disabled="submitting || disabled"
        />

        <AgreementField v-model="form['agree']" />

        <button
            type="submit"
            class="btn mb-5 h-12 w-full text-base"
            :disabled="submitting || disabled"
        >
            {{ submitting || disabled ? "處理中..." : "確定" }}
        </button>

        <ul class="text-center text-sm">
            <li>
                <nuxt-link
                    :to="localePath('/auth/login')"
                    class="font-bold text-primary desk:hover:underline"
                >已有帳號，登入</nuxt-link>
            </li>
        </ul>
    </form>
</template>

<script>
import AgreementField from "@/components/forms/AgreementField.vue";
import { assertSixDigitOtp } from "@/utils/otp";
export default {
    components: {
        AgreementField,
    },
    props: {
        disabled: Boolean,
    },
    data() {
        return {
            form: {
                type: "register",
                country_code: this.defaultCountryCode,
                tel: "",
            },
            submitting: false,
        };
    },
    methods: {
        async submit() {
            if (this.submitting || this.disabled) return;
            if (!assertSixDigitOtp(this.form.tel_verify_code, (msg) => this.$loader.error(msg))) return;
            try {
                this.submitting = true;
                await this.$axios.post("/api/register", this.form);
                if (this.$track) {
                    this.$track.event("sign_up", {
                        method: "phone",
                        country_code: this.form.country_code,
                    });
                }
                this.$emit("login", {
                    country_code: this.form.country_code,
                    identity: this.form.tel || this.form.email,
                    password: this.form.password,
                });
            } catch (e) {
                if (e && e.response) {
                    this.handleErrorsMessage(e);
                } else {
                    this.$loader.error("註冊失敗，請稍後再試");
                }
            } finally {
                this.submitting = false;
            }
        },
    },
};
</script>

<style lang="scss" scoped></style>
